import { Amplify } from 'aws-amplify';
import { AWSConfig } from '../config/aws';
import { LoginType } from '../api-types/models/LoginDto';

// Store login type to localStorage to define user pool for logged in users
export function setConfig(loginType: LoginType, config: AWSConfig) {
    localStorage.setItem('login', loginType);
    const authConfig = config.Auth[loginType];
    if (authConfig) {
        Amplify.configure({
            Auth: {
                Cognito: {
                    userPoolId: authConfig.userPoolId ?? '',
                    userPoolClientId: authConfig.userPoolWebClientId ?? '',
                    loginWith: {
                        oauth: {
                            domain: authConfig.oauth.domain ?? '',
                            scopes: authConfig.oauth.scope,
                            redirectSignIn: [
                                authConfig.oauth.redirectSignIn ?? ''
                            ],
                            redirectSignOut: [
                                authConfig.oauth.redirectSignOut ?? ''
                            ],
                            responseType: 'code'
                        }
                    }
                }
            }
        });
    }
}
